export const getFixtureDate = (fixture) => {
  const date = new Date(`${fixture}Z`);
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();

  return new Date(year, month, day);
};
